import * as React from 'react';
import { IconButton } from '@mui/material';
import { AttachedFile } from 'modules/gallery';
import CloseIcon from "@mui/icons-material/Close";
import HoverText from 'modules/documents/components/action-buttons/hoverText';
import { DragIndicator } from '@mui/icons-material';

import './styles/inlineGallery.sass';

const InlineGalleryPreviewItem: React.FunctionComponent<GalleryItemProps> = props => {
    const [buttonsVisible, setButtonsVisible] = React.useState(false);

    const onClickDelete = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        props.onRemoveImage(props.image);
        e.stopPropagation();
    };

    const isOnlyImage = (props.isFirst && props.isLast);

    return (
        <div
            onClick={() => props.onSelectImage(props.image)}
            onMouseEnter={() => setButtonsVisible(true)}
            onMouseLeave={() => setButtonsVisible(false)}
            id={props.image.blobId}
            className="inline-gallery-image"
        >
            {!isOnlyImage && buttonsVisible &&
                <React.Fragment>
                    <div>
                        <HoverText 
                            label={
                                <IconButton 
                                    onMouseDown={() => props.onDrag(props.index, props.image.ospreyId)}
                                    size="small" 
                                    edge="end" 
                                    className={`rearrange-icon-container ${props.isFirst && "first"} ${props.isLast && "last"}`}
                                >
                                    <DragIndicator id={`ig-drag-icon-${props.index}`} htmlColor="#3b78ab" />
                                </IconButton>
                            }
                            popoverProps={{anchorOrigin: {
                                vertical: "top",
                                horizontal: "left"
                            }}}
                            labelContainerClassName="rearrange-icon-text"
                        >
                            Reorder
                        </HoverText>

                        <HoverText 
                            label={
                                <IconButton 
                                    onClick={(e) => onClickDelete(e)} 
                                    size="small" 
                                    edge="end" 
                                    className={`close-icon-container ${props.isFirst && "first"} ${props.isLast && "last"}`}
                                >
                                    <CloseIcon className="close-icon"/>
                                </IconButton>
                            }
                            popoverProps={{anchorOrigin: {
                                vertical: "top",
                                horizontal: "left"
                            }}}
                            labelContainerClassName="close-icon-text"
                            labelClassName="close-icon-label"
                        >
                            Remove
                        </HoverText>
                    </div>
                </React.Fragment>
            }
            <img 
                src={props.image.fileUrl ?? ""} 
                className={`image ${props.dropClass} ${(props.isFirst && !isOnlyImage) && "first"} ${(props.isLast && !isOnlyImage) && "last"}`}
                alt={`Gallery preview item in list. Filename: ${props.image.fileName}`}
                draggable={false}
            />
        </div>
    );
}

interface GalleryItemProps {
    image: AttachedFile;
    isFirst: boolean;
    isLast: boolean;
    index: number;
    dropClass: string;
    onSelectImage: (image: AttachedFile) => void;
    onRemoveImage: (image: AttachedFile) => void;
    onSwapForwards: () => void;
    onSwapBackwards: () => void;
    onDrag: (idx: number, id: string) => void;
};

export default(InlineGalleryPreviewItem);